import React, { Component } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Edit as CustomerCompany } from "@/views/base/company/Edit";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";

export function Company({...props}) {
  const { register, handleSubmit, watch, reset,    formState, setValue } = useForm({
      defaultValues: props.data,
      values: props.data
    })
    //setValue("type", props.data.type.toString() );

const tabs = [


  { name: 'Klant gegevens', href: '#', icon: UserIcon, current: true },
]  // More people...

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

   const onSubmit: SubmitHandler = (data) => {
    event.preventDefault();
    event.stopPropagation();

    props.onSaveHandler(data);
      
    return false;

    }
/*
  React.useEffect(() => {
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["key"] && formState.defaultValues["key"] != "") {
            for (const [key, value] of Object.entries(formState.defaultValues)) {
                formState.defaultValues[key] = "";
            }          
            reset(formState.defaultValues, { keepDirtyValues: true }); 
      }
  }, [formState, reset])
*/

  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    props.onSaveHandler(data);
      
    return false;
  };
  return (
    <>
                        
    <div className="space-y-10 divide-y divide-gray-900/10 mt-8">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

          <div className="px-4 py-6 sm:p-8">
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                  <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null} />
    
                    
                <CustomerCompany {...props} register={register} registerkey="company."/>

                </div>
          </div>
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="/team" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
        
        </form>
      </div>
      </div>

    


    </>
      );
}
